module.exports = __webpack_public_path__ + "img/Icons-38_pc.7256760b.jpg";